import React from 'react';

const ChevronRightIcon = ({ color = '#6B7280' }: { color?: string }) => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.39786 12.3664L10.3893 7.37044C10.4833 7.27635 10.5371 7.14122 10.5371 6.99959C10.5371 6.85796 10.4833 6.72284 10.3893 6.62874L5.39786 1.63281L4.8125 2.37394L9.43364 6.99959L4.8125 11.6252L5.39786 12.3664Z"
        fill={color}
      />
      <path
        d="M4.76771 11.6217C4.76652 11.6448 4.77323 11.6676 4.78674 11.6849L5.36591 12.4261C5.39411 12.4621 5.4428 12.4655 5.47454 12.4335L10.4133 7.43753C10.5228 7.32677 10.5855 7.16771 10.5855 7.00117C10.5855 6.83463 10.5228 6.67556 10.4133 6.56481L5.47454 1.56887C5.4428 1.53684 5.39411 1.5402 5.36591 1.57628L4.78674 2.31741L4.77172 2.34703C4.76848 2.35774 4.76712 2.36912 4.76771 2.38064C4.76891 2.40381 4.778 2.42561 4.79324 2.44103L9.30049 7.00117L4.79324 11.5613C4.778 11.5767 4.76891 11.5985 4.76771 11.6217ZM9.46769 7.06668C9.4841 7.05007 9.49372 7.02616 9.49372 7.00117C9.49372 6.97617 9.4841 6.95226 9.46769 6.93565L4.95293 2.36811L5.42948 1.75743L10.3112 6.69583C10.3877 6.77326 10.4313 6.88448 10.4313 7.00117L10.4293 7.04446C10.4199 7.14504 10.3781 7.23872 10.3112 7.3065L5.42948 12.2443L4.95293 11.6337L9.46769 7.06668Z"
        fill={color}
      />
    </svg>
  );
};

export default ChevronRightIcon;
